//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "PackageCourse",
  props: {
    course: {
      type: Object,
      default: function _default() {}
    },
    is_small_course_open: Number
  },
  methods: {
    onCourseClick: function onCourseClick() {
      if (this.is_small_course_open == 1) return;
      this.$router.push({
        name: "CourseShow",
        params: {
          id: this.course.course_id
        }
      });
    }
  }
};